import React, { useContext, useEffect } from "react";
import { Button, Table, Segment, Grid, Popup, Divider, Header, Icon } from "semantic-ui-react";
import TransmissionStore from "../../../app/stores/transmissionStore";
import { observer } from "mobx-react-lite";
import { RouteComponentProps } from "react-router";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import TransmissionTab from "./TransmissionTab";
import { Link } from "react-router-dom";
interface DetailParams {
  id: string;
}

const TransmissionDetails: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history,
}) => {
  
  const transmissionStore = useContext(TransmissionStore);
  const {
    transmission,
    loadTransmission,
    loadWarehouses,
    loadWarehouseLogs,
    loadTechnicians,
    loadTaskAssignments,
    loadingInitial,
    loadProjectLogs,
    reload,
    loadProjectScopes,
    loadProjectVendors,
    loadProjectDocuments,
    clearPage,
  } = transmissionStore;

  useEffect(() => {
    loadTransmission(match.params.id);
    loadProjectScopes(match.params.id);
    loadWarehouses();
    loadTechnicians();
    loadWarehouseLogs(match.params.id);
    loadProjectVendors(match.params.id);
    loadTaskAssignments(match.params.id);
    loadProjectLogs(match.params.id);
    loadProjectDocuments(match.params.id);

    return () => {
      clearPage();
    };
  }, [match.params.id]);

  if (loadingInitial || !transmission)
    return <LoadingComponent content="Loading Transmission ..." />;

  return (
    <Segment>
      <Grid>
        <Grid.Column width={3} textAlign="right">
          <span style={{ color: "blue", fontSize: 16 }}>Project Code:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Status:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Company:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Site Id:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Site Name:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>State:</span>
          <br></br>      
          <span style={{ color: "blue", fontSize: 16 }}>Change Request#:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>
            Change Request Dates:
          </span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Address:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Remark:</span>
          <br></br>
        </Grid.Column>
        <Grid.Column width={6}>
          <span style={{ fontSize: 16 }}>{transmission!.projectCode}</span>
          <br></br>
          <span style={{ fontSize: 16 }}><strong>{transmission.status}</strong></span>
          <br></br>
          <span style={{ fontSize: 16 }}>
            {transmission.orderNumber}
          </span>
          <br></br>
          <span style={{ fontSize: 16 }}>
          <Link to={`/projectmanagement/sitevodafone?siteid=${transmission.projectSite.siteId}`} style={{ color: "blue" }}>
            {transmission.projectSite.siteId}</Link>
          </span>
          <br></br>
          <span style={{ fontSize: 16 }}>
            {transmission.projectSite.siteName}
          </span>
          <br></br>
          <span style={{ fontSize: 16 }}>{transmission.projectSite.state}</span>
          <br></br>
          
          <Popup
            trigger={
              <div style={{ fontSize: 16 }}>
                {(transmission.projectSite.changeRequest[0].changeRequestNumber === '') ?
                '\xa0' : transmission.projectSite.changeRequest[0].changeRequestNumber}
              </div>
            }
          >
            <Popup.Content>
              Past Change Requests
              <Table>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>#</Table.HeaderCell>
                    <Table.HeaderCell>Dates</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {transmission.projectSite.changeRequest.map(
                    (cr) =>
                      cr.changeRequestNumber !==
                        transmission.projectSite.changeRequest[0]
                          .changeRequestNumber && (
                        <Table.Row key={cr.id}>
                          <Table.Cell> {cr.changeRequestNumber} </Table.Cell>
                          <Table.Cell> {cr.dates} </Table.Cell>
                        </Table.Row>
                      )
                  )}
                </Table.Body>
              </Table>
            </Popup.Content>
          </Popup>
          <span style={{ fontSize: 16 }}>
            {transmission.projectSite.changeRequest[0].dates}
          </span>
          <br></br>
          <span style={{ fontSize: 16 }}>{transmission!.projectSite.address}</span>
          <Popup
              content="Open in google map"
              trigger={
                  <a href={`https://maps.google.com/?q=${transmission!.projectSite.address}`} target="_Blank">
                    <Icon name='map marker alternate' size='large'/>
                  </a>
                      }
            />
          <br></br>
          <span style={{ fontSize: 16 }}>{transmission!.remark}</span>
          <br></br>
        </Grid.Column>
        <Grid.Column width={3} textAlign="right">
          <span style={{ color: "blue", fontSize: 16 }}>Type:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Ring Id:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Upstream Site Id:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Upstream Site Name:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Upstream WP:</span>
          <br></br>      
          <span style={{ color: "blue", fontSize: 16 }}>Sequence:</span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>
             Forecast Date:
          </span>
          <br></br>
          <span style={{ color: "blue", fontSize: 16 }}>Work Shift:</span>
          <br></br>
        </Grid.Column>
        <Grid.Column width={4}>
          <span style={{ fontSize: 16 }}>{transmission.projectSite.structureType}</span>
          <br></br>
          <span style={{ fontSize: 16 }}>{transmission.projectSite.ringId}</span>
          <br></br>
          <span style={{ fontSize: 16 }}>
            <Link to={`/projectmanagement/sitevodafone?siteid=${transmission.projectSite.upstreamSiteId}`} style={{ color: "blue" }}>
            {transmission.projectSite.upstreamSiteId}</Link>
          </span>
          <br></br>
          <span style={{ fontSize: 16 }}>
            {transmission.projectSite.upstreamSiteName}
          </span>
          <br></br>
          <span style={{ fontSize: 16 }}>{transmission.projectSite.upstreamWP}</span>
          <br></br>
          <span style={{ fontSize: 16 }}>
            {transmission.projectSite.sequence}
          </span>
          <br></br>
          <span style={{ fontSize: 16 }}>{transmission.estimatedCompletionDate}</span>
          <br></br>
          <span style={{ fontSize: 16 }}>{transmission.projectSite.time}</span>
          <br></br>
          <Button
            onClick={() => history.push("/projectmanagement/transmission")}
            color="grey"
            floated="right"
            content="Cancel"
          />
          <Button
            as={Link}
            to={`/projectmanagement/transmission-edit/${transmission.id}`}
            color="blue"
            floated="right"
            content="Edit"
          />
        </Grid.Column>
      </Grid>
      <Divider horizontal >
      <Header as='h4'>
        <Icon name='arrow alternate circle down' />
        Details
      </Header>
    </Divider>
      <TransmissionTab />
    </Segment>
  );
};

export default observer(TransmissionDetails);
